<div id="home-page">
  <div class="cover-photo" style="position: relative; z-index: 3; left: 0; right: 0; height: 200px">
  </div>

  <div id="instance-content" class="extra-light-grey-cfa-languedoc-bg" style="position: relative; z-index: 10;">
    <div class="container white-bg" style="position: relative; z-index: 11;">

      <div style="margin-left: -15px; margin-top: -110px !important; position: absolute; z-index: 12;">
          <h1 class="col-12 p-2 bandeau-title entete font-weight-bold" style="display: table">
            Demande d'information
          </h1>
          <h2 *ngIf="instance?.titre_produit" class="col-12 p-2 bandeau-subtitle ligne font-weight-bold">
            {{instance.titre_produit}} 
          </h2>
      </div>    

      <div class="row px-5">

        <div *ngIf="isSent" class="col-12 text-center mt-12 my-5">
          <h2 class="center blue-cfa-languedoc pb-5">Confirmation</h2>
          <p class="mx-5">
            Votre candidature a bien envoyée !<br>
            Nous reviendrons vers vous prochainement.
          </p>
        </div>

        <div class="col-12 mt-5" *ngIf="!isSent">

          <!-- MON DIPLOME -->
          <p class="mb-4">
            <span class="section-title">
              MON DIPLÔME
            </span>
          </p>
          <span>
            {{instance.titre_produit}} - {{instance.cible}}
          </span>

          <!-- MON INSCRIPTION -->
          <p class="my-4">
            <span class="section-title">
              MON INSCRIPTION
            </span>
          </p>
          <span>
            Je souhaite m'inscrire :
          </span>
          <br>
          <label>
            <input type="radio" name="type_formation" id="type_formation_1" value="alternance" [(ngModel)]="candidatureForm.type_formation" required>
            <span class="px-1">En Alternance dans une entreprise (la formation est gratuite et l'alternant perçoit un salaire)</span>
          </label>
          <br>
          <label>
            <input type="radio" name="type_formation" id="type_formation_2" value="initial" [(ngModel)]="candidatureForm.type_formation" required>
            <span class="px-1">En Initial sans contrat en entreprise (la formation est payante, nous consulter)</span>
          </label>
          <br>
          <label>
            <input type="radio" name="type_formation" id="type_formation_2" value="mixte" [(ngModel)]="candidatureForm.type_formation" required>
            <span class="px-1">Mixte (l'étudiant peut suivre les cours 6 mois tout en cherchant une entreprise d'accueil)</span>
          </label>

          <!-- MES COURS -->
          <p class="my-4">
            <span class="section-title">
              MES COURS
            </span>
          </p>
          <span>
            Je préfère des cours :
          </span>
          <br>
          <label>
            <input type="radio" name="cours" id="cours_1" [value]="true" [(ngModel)]="candidatureForm.cours_presentiels_uniquement" required>
            <span class="px-1">entièrement présentiels</span>
          </label>
          <br>
          <label>
            <input type="radio" name="cours" id="cours_2" [value]="false" [(ngModel)]="candidatureForm.cours_presentiels_uniquement" required>
            <span class="px-1">présentiels certains jours, et avec une partie en visio à distance</span>
          </label>

          <!-- MON ENTREPRISE -->
          <p class="my-4">
            <span class="section-title">
              MON ENTREPRISE
            </span>
          </p>
          <label>
            <input type="radio" name="entreprise_1" id="entreprise_1" [value]="true" [(ngModel)]="candidatureForm.recherche_entreprise" required>
            <span class="px-1">Je recherche une entreprise pour mon alternance, je voudrais recevoir des propositions</span>
          </label>
          <br>
          <label>
            <input type="radio" name="entreprise_2" id="entreprise_2" [value]="false" [(ngModel)]="candidatureForm.recherche_entreprise" required>
            <span class="px-1">J'ai déjà trouvé une entreprise qui peut m'accueillir en apprentissage</span>
          </label>

          <br><br>

          <ng-container *ngIf="instance?.question_specifique">
            <span>
              {{instance.question_specifique}}
            </span>
            <br>
            <br>
            <div class="row">

              <div class="col-12 col-sm-6 col-md-4 col-lg-3" *ngFor="let choix of choixSpe; let i=index">
                <label (click)="onChoixClick($event)">
                  <input type="checkbox" checked [name]="'secteur_'+ i" [id]="'secteur_'+ i" [value]="choix">
                  <span class="px-1">{{choix}}</span>
                </label>
              </div>
            </div>
          </ng-container>

          <!-- MES COORDONNEES -->
          <p class="my-4">
            <span class="section-title">
              MES COORDONNEES
            </span>
          </p>

          <div class="row">
            <div class="col-sm-4 col-md-2 py-1">
              <span>Nom*</span>
            </div>
            <div class="col-sm-8 col-md-4 py-1">
              <input name="candidatureForm_nom" id="candidatureForm_nom" [(ngModel)]="candidatureForm.nom" maxlength="20" type="text" class=" border" (blur)="verifNom($event)" required>
            </div>
            <div class="col-sm-4 col-md-2 py-1">
              <span>Prénom*</span>
            </div>
            <div class="col-sm-8 col-md-4 py-1">
              <input name="candidatureForm_prenom" id="candidatureForm_prenom" [(ngModel)]="candidatureForm.prenom" maxlength="20" type="text" class=" border" (blur)="verifNom($event)" required>
            </div>

            <div class="col-sm-4 col-md-2 py-1">
              <span>Email*</span>
            </div>
            <div class="col-sm-8 col-md-4 py-1">
              <input name="email" id="email" maxlength="20" [(ngModel)]="candidatureForm.email" type="email" maxlength="40" class=" border" (blur)="verifMail($event)" required>
            </div>
            <div class="col-sm-4 col-md-2 py-1">
              <span>Téléphone*</span>
            </div>
            <div class="col-sm-8 col-md-4 py-1">
              <input name="tel" id="tel" minlength="10" maxlength="15" [(ngModel)]="candidatureForm.telephone" type="text" class=" border" required (blur)="verifTel($event)">
            </div>

            <div class="col-sm-4 col-md-2 py-1">
              <span>Date de naissance*</span>
            </div>
            <div class="col-sm-8 col-md-4 py-1">
              <input name="candidatureForm_birthday" id="candidatureForm_birthday" [(ngModel)]="candidatureForm.birthday" maxlength="20" type="date" class=" border" required>
            </div>
          </div>

          <br>

          <div class="row">
            <div class="col-sm-4 col-lg-2 py-1">
              <span>Je suis*</span>
            </div>
            <div class="col-sm-8 col-lg-4 py-1">
              <select name="annee_bac" style="width: 100%" id="annee_bac" class="border white-bg" [(ngModel)]="candidatureForm.annee_bac" required>
                <option [value]="bachelier">{{bachelier}}</option>
                <option [value]="futur_bachelier">{{futur_bachelier}}</option>
                <option value="Autre">Autre</option>
              </select>
            </div>
          </div>

          <br>

          <div class="row">
            <div class="col-sm-4 col-lg-2 py-1">
              <span>Je joins mon CV*</span>
            </div>
            <div class="col-sm-8 col-lg-4 text-center">
                <input class="col-12" style="display: none" type="file" accept="image/jpeg,image/png,application/pdf" (change)="onFileChangedEdition($event)" #fileInput>
                <input class="col-6" type="text" name="image_url" disabled [value]="file_name" required>
                <button class="col-6 edit-button" (click)="fileInput.click()">Choisir un CV</button>
                <br>
                <p class="italic small text-left">Seuls les fichiers PNG, JPEG et PDF sont acceptés.</p>
            </div>
          </div>

          <br>

          <div class="row">
            <div class="col-12 py-1">
              <span>Résumez succintement votre motivation et/ou votre projet</span>
            </div>
            <div class="col-12">      
              <textarea name="message" id="message" [(ngModel)]="candidatureForm.observation" type="text" class="white-bg green-border col-12" required></textarea>                       
          </div>
          </div>

          <p *ngIf="error" class="red-cfa-languedoc py-2">{{error}}</p>

          <div class="col-12 col-sm-7 col-md-6 col-lg-7 text-center my-5 button-div">
            <a class="bouton-inscription entete ombre-clickable col-12" (click)="submit()"> ENVOYER MA DEMANDE </a>
          </div>

        </div>

      </div>

    </div>
  </div>
</div>